<template>
    <v-container>
        <v-card :elevation="0" :loading="loadingcomentario" :disabled="loadingcomentario" outlined>
            <v-card-title>
                <v-icon color="primary">fa-solid fa-comments</v-icon>
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn class="ma-2" color="primary" dark @click="nuevocomentario" :disabled="lectura"
                    v-show="EsConceptoTecnico == false">Comentar
                    <v-icon dark right>fa-solid fa-comment</v-icon>
                </v-btn>

            </v-card-title>
            <v-card-text v-show="EsConceptoTecnico == false">
                <v-data-table dense :headers="HeaderComentarios" :items="ListComentarios.filter((p) => p.idcampo === campo)" class="elevation-1"
                    :no-data-text="gnodata" :items-per-page="5" item-key="idcomentario">
                    <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon small v-on="on" v-show="!lectura" @click="editarcomentario(item)" class="mr-2">edit</v-icon>
                            </template>
                            <span>Editar comentario...</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.fechamodificacion="{ item }">{{ formato(item.fechamodificacion) }}</template>
                </v-data-table>
            </v-card-text>



            <v-card-text v-show="EsConceptoTecnico == true" v-if="ListComentarios.filter((p) => p.idcampo === campo).length > 0 ">
                <v-data-table dense :headers="HeaderComentariosConceptoT"
                    :items="ListComentarios.filter((p) => p.idcampo === campo)" class="elevation-1"
                    :no-data-text="gnodata" :items-per-page="5" item-key="idcomentario">
                    <template v-slot:[`item.estadoFlujo`]="{ item }">
                        <div v-if="item.estadoFlujo == true">Aprobado</div>
                        <div v-else-if="item.estadoFlujo == false">Rechazado</div>
                        <div v-else></div>
                    </template>
                    <template v-slot:[`item.descripcion`]="{ item }">
                        <div v-html="item.descripcion"></div>
                    </template>
                    <template v-slot:item.fechamodificacion="{ item }">{{ formato(item.fechamodificacion) }}</template>

                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialogComentario" max-width="600px">
            <v-card>
                <v-card-title>
                    Comentar
                    <hr>
                </v-card-title>
                <v-card-text>
                    <br>
                    <v-flex xs12 sm12 md12>
                        <label class="v-label primary--text">Escriba su comentario:</label>
                        <v-textarea v-model="edititemcomentario.descripcion" clearable :counter="500" outlined
                            :disabled="!puedeeditar">
                        </v-textarea>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secundary" @click="cancelarcomentario">
                        <v-icon small right color="white">fa-regular fa-stop</v-icon>
                        Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="guardarcomentario" :disabled="!puedeeditar">Guardar
                        <v-icon small right color="white">fa-regular fa-check</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" :timeout="4000" :color="MesaggeInfo.color">
            {{ this.MesaggeInfo.codigoRespuesta }}
            {{ this.MesaggeInfo.mensajeRespuesta }}
            <v-btn text @click="snack = false">Aceptar</v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
    name: "Plantilla_comentarios",
    data: function () {
        return {
            ListComentarios: [],
            permitenacional: false,
            loadingcomentario: false,
            editindexcomentario: -1,
            edititemcomentario: {},
            dialogComentario: false,
            MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
            snack: false,
            idcurrentuser: -1,
            puedeeditar: false,
            HeaderComentarios: [
                { text: "Realizado por", value: "persona", align: "center" },
                { text: "Realizado el", value: "fechamodificacion", align: "center" },
                { text: "Comentario", value: "descripcion", align: "center" },
                { text: " ", value: "action", sortable: false },
            ],
            HeaderComentariosConceptoT: [
                { text: "Realizado por", value: "persona", align: "center" },
                { text: "Realizado el", value: "fechamodificacion", align: "center" },
                { text: "Comentario", value: "descripcion", align: "center" },
                { text: "Decisión", value: "accion", align: "center" },
                { text: " ", value: "action", sortable: false },
            ],
        };
    },
    props: {
        tabla: { type: Number, required: true },
        elemento: { type: Number, required: true },
        campo: { type: Number, required: true },
        title: { type: String, required: false },
        lectura: { type: Boolean, required: false },
        EsDelagado: { type: Boolean, required: true },
        EsConceptoTecnico: { type: Boolean, required: false, default: false, },
        rolbyAccion: { type: Number, required: false, default: false, },
        idflujoaccion: { type: Number, required: false, default: false, }
    },
    created() {
        this.get_comentarios({ params: { idtabla: this.tabla, idelemento: this.elemento, isUserDelegate: this.EsDelagado } }) // campo meta
    },
    methods: {
        ...mapActions(["get_comentarios", "put_comentario"]),
        nuevocomentario() {
            this.dialogComentario = true;
            this.edititemcomentario = {
                idcomentario: 0,
                idtabla: this.tabla,
                idcampo: this.campo,
                idelemento: this.elemento,
                descripcion: "",
                fechacreacion: "2000-03-22T13:24:47.37",
                fechamodificacion: "2000-03-22T13:24:47.37",
                usuariocreacion: -1,
                usuariomodificacion: -1,
                idflujo: this.idflujoaccion,
                rolaccion: this.rolbyAccion
            }
            this.puedeeditar = true;
        },
        editarcomentario(item) {
            this.puedeeditar = false;
            this.dialogComentario = true;
            this.editindexcomentario = this.ListComentarios.indexOf(item);
            this.edititemcomentario = Object.assign({}, item);
            if (this.getusuario() != null) {
                this.idcurrentuser = this.getusuario().idusuario;
                if (this.edititemcomentario.usuariomodificacion == this.idcurrentuser)
                    this.puedeeditar = true;
            }
        },
        cancelarcomentario() {
            this.dialogComentario = false;
            this.editindexcomentario = -1;
            this.edititemcomentario = {};
        },
        guardarcomentario() {
            if (this.editindexcomentario > -1) {
                Object.assign(this.ListComentarios[this.editindexcomentario], this.edititemcomentario);
                this.loadingcomentario = true;
                this.put_comentario({ data: this.edititemcomentario })
            } else {
                this.ListComentarios.push(this.edititemcomentario);
                this.loadingcomentario = true;
                this.put_comentario({ data: this.edititemcomentario })
            }
            this.cancelarcomentario();
            this.puedeeditar = false;
        },
        getusuario() {
            if (localStorage.usuario !== undefined) {
                return JSON.parse(unescape(localStorage.usuario));
            } else {
                return null;
            }
        },
        formato(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY");
            }
        },
    },
    computed: {
        ...mapGetters(["gcomentarios"]),
        ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    },
    watch: {
        gcomentarios: function () {
            this.ListComentarios = this.gcomentarios;
        },
        ginformation: function () {
            if (this.loadingcomentario) {
                this.MesaggeInfo = this.ginformation;
                this.snack = true;
                console.log(this.MesaggeInfo.mensajeRespuesta);
            }
            this.loadingcomentario = false;
        }
    }
};
</script>